module.exports = __webpack_public_path__ + "img/Estee Lauder.41ed45c8.jpg";